import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { useLocation } from 'react-router-dom'

import { Loader } from 'rsuite'

import { clearFiles, clearStudents, deleteFile, getFiles, getStudents, uploadPortfolio } from '../../../../bll/portfolio/portfolioOperations'
import { AppStateType } from '../../../../bll/store'
import openNotification from '../../../_ui/notification'
import errorHandler from '../../../../bll/errorHandler'
import Students from './students'

const StudentsContainer = (props: any) => {
    interface CustomizedState {
        oid: string,
        Name: string,
        Year: number
    }

    const location = useLocation()
    const url = location.state as CustomizedState

    const [isVisibleLoader, setIsVisibleLoader] = React.useState(false) // Видимость компоненты Loader
    const [isVisibleLoaderFiles, setIsVisibleLoaderFiles] = React.useState(false) // Видимость компоненты Loader

    const [getFilterStudentFIO, setFilterStudentFIO] = React.useState('') // Фильтр ФИО студента
    const [selectedStudentID, setSelectedStudentID] = React.useState('') // Идентификтаор выбранного студента

    React.useEffect(() => {
        setIsVisibleLoader(true)

        props.getStudents(url.oid).then((result: any) => {
            setIsVisibleLoader(false)
                
            switch (result?.code) {
                case "ERR_QUERY_STRING": { return openNotification("Список студентов...", props.msg.err_0038, "error", "bottomRight") }
                default: errorHandler(result?.code, props.msg); break
            }
        })

        return () => {
            props.clearStudents()
            props.clearFiles()
        }
    }, [url]) // eslint-disable-line react-hooks/exhaustive-deps


    // Функция по загрузке файлов студента
    const loadedFiles = (studentID: any) => {
        setIsVisibleLoaderFiles(true)

        props.getFiles(studentID).then((result: any) => {
            setIsVisibleLoaderFiles(false)

            switch (result?.code) {
                case "ERR_QUERY_STRING": { return openNotification("Список файлов...", props.msg.err_0039, "error", "bottomRight") }
                default: errorHandler(result?.code, props.msg); break
            }
        })
    }

    // Выбор студента и загрузка файлов
    const onSelectedStudent = (value: string) => {
        if (selectedStudentID) { // Если студент выбран
            if (selectedStudentID === value) { // Если предыдущий студент совпадает с текущем выбором
                props.clearFiles() // Очищаем в stor файлы
                setSelectedStudentID('') // Очищаем выбранного студента
            } else {
                setSelectedStudentID(value)
                loadedFiles(value) // Загрузка файлов
            }
        } else {
            setSelectedStudentID(value)
            loadedFiles(value) // Загрузка файлов
        }
    }

    // Функция по загрузке файлов на сервер
    const fileUploader = (fileList: any, fileType: string) => {
        // setIsVisibleLoaderFiles(true)

        fileList.forEach((file: any) => {
            props.uploadPortfolio(file, selectedStudentID, fileType, file.name).then((result: any) => {
                // setIsVisibleLoaderFiles(false)

                switch (result?.code) {
                    case "ERR_QUERY_STRING": { return openNotification("Ошибка загрузки файла...", props.msg.err_0040, "error", "bottomRight") }
                    case "ERR_FILE_NOT_FOUND": { return openNotification("Ошибка загрузки файла...", props.msg.err_0013, "error", "bottomRight") }
                    case "ERR_FILE_EXTNAME": { return openNotification("Ошибка загрузки файла...", props.msg.err_0023, "error", "bottomRight") }
                    case "ERR_FILE_SIZE": { return openNotification("Ошибка загрузки файла...", props.msg.err_0024, "error", "bottomRight") }
                    case "ERR_FILE_NAME": { return openNotification("Ошибка загрузки файла...", props.msg.err_0041, "error", "bottomRight") }
                    case "ERR_FILE_PREFIX": { return openNotification("Ошибка загрузки файла...", props.msg.err_0042, "error", "bottomRight") }
                    case "ERR_FILE_FIO": { return openNotification("Ошибка загрузки файла...", props.msg.err_0043, "error", "bottomRight") }
                    default: errorHandler(result?.code, props.msg); break
                }
            })
        })
    }

    // Удаление файла
    const onClickButtonDeleteFile = (filetID: number) => {
        props.deleteFile(filetID, selectedStudentID).then((result: any) => {
            switch (result?.code) {
                case "ERR_QUERY_STRING": { return openNotification("Удаление файла...", props.msg.err_0044, "error", "bottomRight") }
                default: errorHandler(result?.code, props.msg); break
            }
        })
    }

    // Свойства передаваемые в компоненту
    const propsToStudents = {
        groupName: url.Name, // Имя выбранной группы
        groupYear: url.Year, // Год выбранной группы

        getFilterStudentFIO, setFilterStudentFIO, // Фильтр ФИО студента

        isVisibleLoaderFiles, // Видимость компоненты Loader
        selectedStudentID, // Идентификтаор выбранного студента
        onSelectedStudent, // Выбор студента и загрузка файлов
        fileUploader, // Функция по загрузке файлов на сервер
        onClickButtonDeleteFile, // Удаление файла
    }

    return (
        <>
            {isVisibleLoader
                ? <div style={{ height: "100%", position: "relative" }}><Loader center size="md" content="Загрузка данных..." vertical /> </div>
                : <Students {...props} {...propsToStudents} />
            }
        </>
    )
}

let mapState = (state: AppStateType) => {
    return {
        msg: state.msg,
        studentsList: state.portfolio.studentsList,
        filesList: state.portfolio.filesList,
    }
}

export default compose(connect(mapState, { getStudents, clearStudents, getFiles, clearFiles, uploadPortfolio, deleteFile }))(StudentsContainer)